<template>
  <div class="box">
    <div class="banner">
      <img :src="banner" alt="">
      <router-link  :to="{path:'/league',query: {sysTtype:sysTtype}}"><div class="banner-btn">申请试用</div></router-link>
    </div>
    <div class="center-box center clearfix">
      <div class="indexCase clearfix">
        <div class="indexTitle-box">
          <h5 class="indexTitle">SYSTEM COMPOSITION</h5>
          <h6 class="indexSubtitle">系统组成</h6>
          <div class="select-head">
            <span :class="selectIndex==1?'center-act':''"  @click="selectCenter(1)">派团后台管理系统</span>
            <span :class="selectIndex==2?'center-act':''" @click="selectCenter(2)">带团助手小程序</span>
            <span :class="selectIndex==3?'center-act':''" @click="selectCenter(3)">跟团助手小程序</span>
          </div>
          <div class="select-center">
            <div class="select-pai" v-if="selectIndex==1">
              <router-link  :to="{path:'/league',query: {sysTtype:sysTtype}}"><div class="btn">申请试用</div></router-link>
            </div>
            <div class="select-dai" v-if="selectIndex==2"></div>
            <div class="select-gen" v-if="selectIndex==3"></div>
          </div>
        </div>
      </div>    
    </div>
    <div class="ApplicationForm">
    </div>
    <div class="flow">
      <img :src="flow" alt=""> 
    </div>
    <div class="pay-flow">
      <router-link  :to="{path:'/league',query: {sysTtype:sysTtype}}"><div class="tryout">申请试用</div></router-link>
    </div>

  </div>
</template>
<script>
  import global_ from './../store/global'
export default {
  name: 'Cooperation',
  data () {
    return {
      selectIndex:1,
      sendSelected:'cooperation',
      colourClass:'',
      banner: global_.imgUrl+'banner2.jpg',
      flow: global_.imgUrl+'flow.jpg',
      advantageIcon: global_.imgUrl+'advantage-icon',
      ApplicationFormIcon: global_.imgUrl+'ApplicationFormIcon',
      href:'#/cooperation/register',
      sysTtype:3
    }
  },
  methods: {
    selectCenter(index){
      this.selectIndex=index
    }
  },
  beforeMount(){
    var session=sessionStorage.getItem('GWcustomer');
    if(session!=null){
      this.href='#/cooperation/information';
    }
  },
  mounted(){
    this.$emit('nav',this.sendSelected,this.colourClass);
  }
  
}
</script>

<style lang="scss" scoped>
  .banner{
    width: 100%;
    height: 700px;
    min-width: 1200px;
    position: relative;
    overflow: hidden;
    img{
      width: 1920px;
      max-width: inherit;
      position: relative;
      left: 50%;
      top: 0;
      margin-left: -960px;
    }
    .banner-btn{
      position: absolute;
      top: 200px;
      left: 0px;
      right: 0px;
      bottom: 0px;
      width: 200px;
      height:50px;
      line-height: 50px;
      text-align: center;
      margin:auto;
      color: #fff;
      background: linear-gradient(to right, #09ba7e 0%,#09bab1 100%);
      border-radius: 4px;
      cursor: pointer;
    }
  }
  .flow{
    width: 100%;
    height: 400px;
    min-width: 1200px;
    position: relative;
    overflow: hidden;
    img{
      width: 1920px;
      max-width: inherit;
      position: relative;
      left: 50%;
      top: 0;
      margin-left: -960px;
    }
  }

  .pay-flow{
    width: 100%;
    height: 538px;
    min-width: 1200px;
    position: relative;
    overflow: hidden;
    background: #00bff6 url('../assets/images/pay_flow.jpg') center center no-repeat;
    .tryout{
      position: absolute;
      top: 300px;
      bottom: 0px;
      left: 0px;
      right:0px;
      margin: auto;
      width:200px;
      height: 50px;
      line-height: 50px;
      text-align: center;
      color: #fff;
      background: linear-gradient(to right, #09ba79 0%,#09bab2 100%);
      border-radius: 4px;
      cursor: pointer;
    }
  }
  .center-box{
    width: 100%;
    height: 890px;
  }

  .indexCase{
    margin: 80px 0 140px;
    .indexTitle-box{
      margin-bottom: 40px;
      text-align: center;
      .indexTitle{
        font-size: 32px;
        font-weight: bold;
        color: #cdeddd;
        line-height: 40px;
      }
      .indexSubtitle{
        font-size: 24px;
        color: #585858;
        line-height: 32px;
        font-weight: normal;
        text-transform:uppercase;
        margin: 5px 0;
      }
    }

    .indexService{
      margin: 60px 0 0;
      display: flex;
      .indexService-li{
        // flex-grow: 1;
        text-align: center;
        width: 25%;
        img{
          display: block;
          margin: 30px auto 20px;
        }
        .advantage-text{
          margin: 0 20px;
          h6{
            font-size: 20px;
            line-height: 28px;
            color: #333; 
            margin-bottom: 10px;
            // text-indent: 15px;
          }
          p{
            font-size: 14px;
            line-height: 24px;
            color: #999; 
          }
        }
        
      }
    }
    
  }
  .ApplicationForm{
    background: #00bff6 url('../assets/images/ApplicationForm_new.jpg') center center no-repeat;
    width: 100%;
    height: 600px;
    min-width: 1200px;
    .indexCase{
      margin: 80px 0;
    }
    .indexTitle-box{
      .indexTitle,.indexSubtitle{
        color: #fff;
      }
      
    }
    .indexService{
      
      .indexService-li{
        .advantage-text{
          h6{
            color: #fff; 
          }
          p{
            color: #fff; 
          }
        }
      }
    }

    
  }
  .JoinUs{
    span{
      width: 18px;
      height: 18px;
      border: 2px solid #ff0000;
      border-bottom:none;
      &.JoinUs-l{
        border-right: none;
      }
      &.JoinUs-r{
        border-left: none;
      }
    }
    .JoinUs-text{
      font-size: 14px;
      color: #333;
      margin: 25px;
      text-align: center;
      line-height: 24px;
    }
    .JoinUs-Btn{
      display: block;
      width: 260px;
      height: 60px;
      text-align: center;
      line-height: 60px;
      border-radius: 10px;
      margin: 0 auto;
      background-color: #ff8c00;
      font-size: 20px;
      color: #fff;
      margin-top: 80px;
      &:hover{
        background-color: #fe981b;
      }
    }
  }
  .select-head{
    color: #363636;
    margin-top: 20px;
    span{
      padding-bottom: 6px;
      margin-right: 100px;
      cursor: pointer;
    }
    span:nth-child(1){
      margin-left: 100px;
    }
    .center-act{
      color: #58d0a4;
      border-bottom: 2px solid #58d0a4;
    }
  }
  .select-center{
    width: 1000px;
    height: 520px;
    margin: 0px auto;
    margin-top: 40px;
    background-color: #f5f5f5;
    .select-pai{
      position: relative;
      width: 100%;
      height:100%;
      background: url('../assets/images/pai.jpg') center 20px no-repeat;
      background-size: 100%;
      .btn{
        width: 90px;
        height: 30px;
        position: absolute;
        left: 0;
        right: 0px;
        top: 310px;
        bottom: 0px;
        margin: auto;
        line-height: 30px;
        color: #5dcfa5;
        text-align: center;
        border-radius: 4px;
        border: 1px solid #5dcfa5;
        cursor: pointer;
      }
    }
    .select-dai{
      width: 100%;
      height:100%;
      background: url('../assets/images/dai.jpg') center 20px no-repeat;
      background-size: 100%;
    }
    .select-gen{
      width: 100%;
      height:100%;
      background: url('../assets/images/gen.jpg') center 20px no-repeat;
      background-size: 100%;
    }

  }

</style>



// WEBPACK FOOTER //
// src/components/cooperation.vue